import type { GscSnapshot } from './gscRollup';
import styles from '../../pages/DashboardPage.module.css';

const CHART_H = 96;
const BAR_W = 8;
const GAP = 4;

type Props = { snapshots: GscSnapshot[] };

export function GscTrendChart({ snapshots }: Props) {
  if (snapshots.length === 0) {
    return (
      <p className={styles.muted}>
        Nog geen GSC-snapshots. Koppel Search Console onder Integraties; sync draait dagelijks om
        03:15 UTC.
      </p>
    );
  }

  const maxVal = Math.max(1, ...snapshots.map((s) => s.metrics.clicks));
  const width = snapshots.length * (BAR_W + GAP) + GAP;

  return (
    <div className={styles.chartWrap}>
      <svg
        className={styles.chartSvg}
        width={width}
        height={CHART_H + 28}
        role="img"
        aria-label="GSC clicks trend"
      >
        {snapshots.map((s, i) => {
          const x = GAP + i * (BAR_W + GAP);
          const h = (s.metrics.clicks / maxVal) * CHART_H;
          const label = s.snapshot_date.slice(5);
          return (
            <g key={s.snapshot_date}>
              <rect
                x={x}
                y={CHART_H - h}
                width={BAR_W}
                height={Math.max(h, s.metrics.clicks > 0 ? 2 : 0)}
                className={styles.chartSvgMail}
              >
                <title>{`${s.snapshot_date} — clicks: ${s.metrics.clicks}`}</title>
              </rect>
              <text x={x + BAR_W / 2} y={CHART_H + 14} className={styles.chartSvgLabel}>
                {label}
              </text>
            </g>
          );
        })}
      </svg>
    </div>
  );
}
